<li class="nav-item dropdown pl-4 pr-2 d-sm-down-none user-bar-nav" dropdown placement="bottom right">
  <a class="nav-link" data-toggle="dropdown" role="button" style="cursor: default;" dropdownToggle>
    <i class="fa fa-user-circle">&nbsp;</i>
    {{userDisplayName$ | async}}
  </a>
</li>
